import React, {Component} from 'react';
import moment from 'moment';
import _ from "lodash";
import IoClose from 'react-icons/lib/io/close';
import {validateUrl, dentistLastMessage} from '../../utils/validator';
import ReactTooltip from "react-tooltip";
import "react-toggle/style.css"
import IoAndroidSend from 'react-icons/lib/io/android-send';
import FaCircle from 'react-icons/lib/fa/circle';
import MdArrowDownward from "react-icons/lib/md/arrow-downward";
import IconSpinner from "react-icons/lib/fa/spinner";
import FaArrowLeft from "react-icons/lib/fa/arrow-left";
import {globals} from '../../../../common/constants';

export default class ChatAdmin extends Component {
    constructor(props){
        super(props);
        this.state = {
            showDentistList: true,
        }
    }
    componentDidUpdate(prevProps) {
        if ((this.props.addedMessage && !prevProps.addedMessage) || (!_.isEqual(this.props.messages, prevProps.messages) && this.props.isScrolledToBottom)) {
            this.props.scrollToBottom(this.messagesAdmin);
            const message = this.props.messages.find(message => message.from === this.props.selectedUser);
            if(message) {
                setTimeout(() => this.props.handleReadMessage(message.id), 2000);
            }
        }
        if(!prevProps.isScrolledToBottom && this.props.isScrolledToBottom) {
            const message = this.props.messages.find(message => message.from === this.props.selectedUser);
            if(message) {
                setTimeout(() => this.props.handleReadMessage(message.id), 2000);
            }
        }
    }

    renderLoader = () => {
        return <h1 className="text-center"><IconSpinner size={20} className="spinner"/></h1>;
    };
    renderLoadMessages = () => {
        const {noMoreMessages} = this.props;
        return <button className="btn-link btn-link-black load__more-btn"
                       onClick={this.props.handleLoadMore}>{noMoreMessages ? 'No More Messages' : 'Load More'}</button>;
    };
    renderLoadMore = () => {
        const {
            noMoreMessages
        } = this.props;
        return <button className="btn-link btn-link-black load__more-btn"
                onClick={this.props.handleLoadMore}>{noMoreMessages ? 'No More Messages' : 'Load More'}</button>
    };
    renderMaximizedChat = () => {
        const {
            selectedUser,
            messages,
            message,
            loadingMessages,
            isScrolledToBottom,
            adminIsOnline
        } = this.props;
        return <div className="chat__maximized-body">
            {adminIsOnline ? null : <div className="chat__maximized__offline">
                We're currently offline.<br/> Please submit your message<br/> and we will get back to
                you<br/> shortly.
            </div>}
            <div className={`chat__maximized__messages ${adminIsOnline ? '' : 'chat__maximized__messages-offline'}`} onScroll={() => this.props.handleScroll(this.messagesEnd)} ref={(el) => {
                this.messagesEnd = el;
            }}>
                {loadingMessages ?
                    this.renderLoader() : this.renderLoadMessages()
                }

                {messages && selectedUser ? this.renderMessages() : null}
                {!isScrolledToBottom ? <button
                    data-tip="Go to bottom"
                    onClick={() => this.props.scrollToBottom(this.messagesEnd)} className="btn btn-fab btn-sm button__arrow__down button__arrow__down-user">
                    <MdArrowDownward size={20}/>
                </button> : null}
                <ReactTooltip place="top" type="light" effect="float"/>
            </div>
            <div className="chat__maximized__actions">
                <button className="chat__maximized__actions-send btn-link btn-link-black"
                        onClick={this.props.addNewMessage}><IoAndroidSend/></button>
                <textarea onKeyPress={this.props.handleKeyPress}
                          onChange={this.props.handleMessageChange}
                          className="message-input" name="message"
                          value={message} placeholder="Type your message"/>
            </div>
        </div>
    }
    renderMaximizedChatIfAdminIsOnline = () => {
        return <div className="chat__maximized">
            <div className="chat__maximized-title">
                <div className="chat__maximized-partner">
                    <FaCircle className="chat__maximized-partner__status" color="#00ff00"/> 
                    Lab Admin
                </div>
                <div className="chat__maximized-icons">
                    <button className="btn-link btn-link-white" onClick={this.props.toggleMinimizedState}><IoClose/>
                    </button>
                </div>
            </div>
            {this.renderMaximizedChat()}
        </div>
    };
    renderMaximizedChatIfAdminIsOffline = () => {
        return <div className="chat__maximized">
            <div className="chat__maximized-title">
                <div className="chat__maximized-partner">
                    <FaCircle className="chat__maximized-partner__status"
                              color="#888888"/>Lab Admin
                </div>
                <div className="chat__maximized-icons">
                    <button className="btn-link btn-link-white" onClick={this.props.toggleMinimizedState}><IoClose/>
                    </button>
                </div>
            </div>
            {this.renderMaximizedChat()}
        </div>
    };
    renderUserSelected = () => {
        const {
            currentUser,
            activeUser,
            onlineUsers,
            selectedUser,
            message,
            messages,
            loadingMessages,
            isScrolledToBottom
        } = this.props;
        return <div className="chat__window__messages">
            <div className="chat__window__title-name">
                <span
                    data-tip="Go to Users"
                    className="kr kr-arrow arrow__back"
                    onClick={() => this.props.handleSelectUser()}
                />
                <FaCircle className="chat__window__user-status"
                          color={onlineUsers.find(item => item === selectedUser.toString())
                              ? "#00ff00" : "#888888"}/>
                {activeUser.first_name + ' '
                + activeUser.last_name}
            </div>
            <div className="chat__window__messages-content" onScroll={() => this.props.handleScroll(this.messagesAdmin)} >
                <div className="live-content">
                    {loadingMessages ? this.renderLoader() : this.renderLoadMore()}
                    {messages.sort((a, b) => (new Date(a.created_at) - new Date(b.created_at))).map(message => (
                        <div key={message.id} className="message-box-holder" ref={(el) => {
                            this.messagesAdmin = el;
                        }}>
                            <div
                                className={`message-box ${currentUser.id === message.from ? '' : 'chat__messages-received'}`} dangerouslySetInnerHTML={{__html: validateUrl(message.message, 'text-white')}}>
                            </div>
                            <div
                                className={`${currentUser.id === message.from ? 'message-sender-sent' : 'message-sender'}`}>
                                {moment(message.created_at).calendar(null, {
                                    sameDay: 'HH:mm',
                                    nextDay: '[Tomorrow] HH:mm',
                                    nextWeek: 'ddd',
                                    lastDay: '[Yesterday] HH:mm',
                                    lastWeek: 'ddd HH:mm',
                                    sameElse: 'DD MMM HH:mm'
                                })}
                            </div>
                        </div>
                    ))}
                    {!isScrolledToBottom ? <button data-tip="Go to bottom"
                                                   onClick={() => this.props.scrollToBottom(this.messagesAdmin)} className="btn btn-fab btn-sm button__arrow__down button__arrow__down-admin">
                        <MdArrowDownward size={20}/>
                    </button> : null}
                    <ReactTooltip place="top" type="light" effect="float"/>
                </div>
            </div>
            <div className="chat__maximized__actions">
                <button className="chat__maximized__actions-send btn-link btn-link-black"
                        onClick={this.props.addNewMessage}>
                    <span className="kr kr-send" />
                </button>
                <textarea onKeyPress={this.props.handleKeyPress}
                       onChange={this.props.handleMessageChange}
                       className="chat__window__messages-input"
                       name="message"
                        rows="5"
                       value={message} placeholder="Type your message"/>
            </div>
        </div>
    };

    renderMobileChat = () => {
        const {
            onlineUsers,
            selectedUser,
            users,
            searchInputValue,
            currentUser
        } = this.props;

        return (
            <div className="chat__users">
                <div className="chat__window__users-search">
                    <input className="chat__window__users-input"
                           onChange={this.props.handleSearchInputChange} placeholder="Search dentist"/>
                    <span className="kr kr-search" />
                </div>
                <div className="chat__window__users">
                    <div className="users-block">
                        {users && users
                            .filter(user => user.first_name.toLowerCase().includes(searchInputValue.toLowerCase())
                                || user.last_name.toLowerCase().includes(searchInputValue.toLowerCase())
                                || (user.first_name + ' ' + user.last_name).toLowerCase().includes(searchInputValue.toLowerCase())).sort((a, b) => new Date(b.message_date) - new Date(a.message_date))
                            .map(user =>
                                <div onClick={() => this.props.handleSelectUser(user)}
                                     className={`chat__window__user ${!user.is_read && user.message_from !== currentUser.id && user.message ? "chat__window__user-unread" : ""} ${selectedUser === user.id ? "chat__window__user-selected" : ""}`}
                                     key={user.id}>
                                    <div className="user-block">
                                        <FaCircle className="chat__window__user-status"
                                                  color={onlineUsers.find(item => item === user.id.toString())
                                                      ? "#54D043" : "#D6D6D6"}/>
                                        <span className="user-block__name">
                                            {user.first_name + ' ' + user.last_name}
                                        </span>
                                    </div>
                                    <p>
                                        {user.message && dentistLastMessage(user.message)}
                                    </p>
                                </div>)}
                    </div>
                </div>
            </div>
        )
    }

    renderChatIfAdminIsOnline = () => {
        const {
            selectedUser,
        } = this.props;
        const isMobile = window.innerWidth < globals.NAV_BIG

        return <div className="chat">
            {!selectedUser && isMobile && this.renderMobileChat()
            }
            {!isMobile && this.renderMobileChat()
            }
            <div className="chat__text">
                {
                    selectedUser ? this.renderUserSelected() :
                    <div className="chat__window__offline">Please select a dentist to start a conversation.</div>
                }
            </div>
        </div>
    };

    render() {
        const {
            activeUser,
            adminIsOnline,
            onlineUsers,
            selectedUser,
            isMinimized,
        } = this.props;
        
        return <div className="view-content">
            <div className="messages">
                <div className="messages__block">
                    <div className="messages__title">
                        <div className="messages__title-text">
                            MESSAGES
                        </div>
                        <div className="messages__title-switcher">
                            <div id="toggle"
                                 className="message-toggle"
                                 data-tip={adminIsOnline ? "Go Offline" : "Go Online"}
                            >
                                <div className="custom-control custom-switch switcher">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="switch1"
                                        name="example"
                                        checked={adminIsOnline}
                                        onChange={this.props.toggleOnlineMode}
                                    />
                                    <label className="custom-control-label" htmlFor="switch1"/>
                                </div>
                            </div>
                            <ReactTooltip for="toggle" place="top" type="light" effect="float"/>
                        </div>
                    </div>
                    <div className="messages__body">
                        {this.renderChatIfAdminIsOnline()}
                    </div>
                </div>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Chat/admin.js